/**
 * WCAG 1.3.1 (Phase 4 G2 / WCAG-B-01) — tableaux de données :
 * `th[scope]` + `<caption>` (visuellement masquée si besoin).
 */

const CAPTION_BY_ID: Record<string, string> = {
  'salaries-table': 'Liste des salariés',
  'bulletins-table': 'Liste des bulletins de paie',
  'saisie-table': 'Saisie mensuelle de paie',
  'dashboard-table': 'Tableau de bord — salariés',
  'pilotage-alerts-table': 'Alertes de pilotage RH',
  'flotte-table': 'Parc véhicules',
  'frais-table': 'Notes de frais',
  'cnss-table': 'Déclaration CNSS',
  'cnamgs-table': 'Déclaration CNAMGS',
  'dgi-table': 'Déclaration DGI',
  'dts-table': 'Déclarations trimestrielles',
};

function resolveCaption(table: HTMLTableElement): string {
  const fromData = table.getAttribute('data-caption')?.trim();
  if (fromData) return fromData;
  const fromAria = table.getAttribute('aria-label')?.trim();
  if (fromAria) return fromAria;
  const id = table.id?.trim();
  if (id && CAPTION_BY_ID[id]) return CAPTION_BY_ID[id]!;
  const section = table.closest('section.view, .card, [data-view]');
  const title =
    section?.querySelector('.page-header h1, .card-title, h2, h3')?.textContent?.trim() ?? '';
  if (title) return `Tableau — ${title}`;
  return 'Tableau de données';
}

/** Ajoute scope + caption manquants sur les tableaux ayant un thead (données). */
export function enhanceDataTables(root: ParentNode = document): number {
  let touched = 0;
  root.querySelectorAll('table').forEach((table) => {
    if (!(table instanceof HTMLTableElement)) return;
    if (!table.tHead) return;

    table.tHead.querySelectorAll('th').forEach((th) => {
      if (!th.getAttribute('scope')) {
        th.setAttribute('scope', 'col');
        touched += 1;
      }
    });
    table.querySelectorAll('tbody th').forEach((th) => {
      if (!th.getAttribute('scope')) {
        th.setAttribute('scope', 'row');
        touched += 1;
      }
    });

    if (!table.caption) {
      const caption = document.createElement('caption');
      caption.className = 'sr-only';
      caption.textContent = resolveCaption(table);
      table.prepend(caption);
      if (!table.getAttribute('aria-label')) {
        table.setAttribute('aria-label', caption.textContent);
      }
      touched += 1;
    } else if (!table.getAttribute('aria-label') && table.caption.textContent) {
      table.setAttribute('aria-label', table.caption.textContent);
    }
  });
  return touched;
}
